import {h, render} from 'preact';
import { pointerDragManager } from './lib/touchhelper';
import 'preact/debug';
import { App } from './components/app';
import { Plugins, Capacitor } from '@capacitor/core'


async function main() {
    //hook global touch handler
    pointerDragManager.initialize(document.getElementById("root"));
   
   /* I feel really bad about this, but safari is the new IE.
    Remove when the 16rems used in the animation on the first word in the tutorial is actually 16 rems and not 12 rems after first load */
    window.setTimeout(()=>{
        render(
        <App></App>
            , document.getElementById('root'));
            if (Capacitor.isPluginAvailable('SplashScreen')) {
                Plugins.SplashScreen.hide();
            }
        }, 10)
}

main()



